<template>
  <span>
    {{translateType(event)}}
      <span v-if="event.type === 'webhook_sent'" class="small">
        <span v-if="event.payload && event.payload.event" class='badge badge-light align-text-top'>{{ event.payload.event }}</span>
      </span>
  </span>
</template>

<script>

  export default {
    props: {
      event: {
        type: Object,
        required: true
      }
    },

    methods: {
      translateType(event) {
        switch (event.type) {
          case 'message_sent':
            return 'Message Sent'
          case 'message_received':
            return 'Message Received'
          case 'webhook_sent':
            return 'Webhook'
          case 'integration_forwarded':
            return `Message Forwarded to ${this.$options.filters.integrationType(event.integration_type)}`
          default:
            return event.type
        }
      }
    }
  }
</script>
